import { useContext, useEffect, useState } from "react";
import { useParams, Link, Navigate, useNavigate, useLocation } from "react-router-dom";
import { Container, Card, Button, Row, Col, Image } from "react-bootstrap";
import { DarshanBook_TempleList } from "../../ApiServices/Darshan Booking/DarshanBookingApi";
import { PoojaAtTemple } from "../../ApiServices/Pooja At Temple/PoojaTempleApi";
import {
  AuthContextProvider,
  LoaderContext,
} from "../../AuthContext/AuthContext";
import LoginPopUp from "../LoginPopup";
import "../../Components/PoojaDetails/PujaDetails.css";
import { GetPoojaAtTempleDetailsBySlug } from "../../ApiServices/SlugsApi/GetPoojaAtTempleDetailsBySlugApi";
import { Helmet } from "react-helmet-async";
import { FaqModuleID } from "../enum";
import { GetFAQListByService } from "../../ApiServices/FAQ/FAQApi";
// API function (replace this with your actual function)
import batuk from "../../assets/images/new/fav-removebg-preview.png";
import ShareLinkModal from "../ShareLinkModal";
import { PujaAtTempleShareMassage } from "../../middlewares/Utils";
const PoojaAtTempleDetails = () => {
  const navigate = useNavigate();

  const [loginPopUp, setLoginPopUp] = useState(null);
  const { isAuthenticated } = useContext(AuthContextProvider);
  const { id } = useParams(); // Get temple ID from URL
  const [temple, setTemple] = useState(null);
  const [loading, setLoading] = useState(true);
  const { slug } = useParams();
  const [FAQ, setFaq] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const location = useLocation()
  const [showModal, setShowModal] = useState(false);
  const [modelRequestData, setModelRequestData] = useState({
    Action: null,
    DARSHAN_PRICE: null,
    DARSHAN_TIME: null,
    TR_ID: null,
    CONVENIENCE_FEE: null,
    TR_SHORTDETAILS: null,

    Row: null,
    PAT_ID: null,
    PAT_NAME: null,
    PAT_PRICE: null,
    PAT_CONVENIENCEFEE: null,
    PAT_IMAGE: null,
    PAT_ADDRESS: null,
    PAT_DETAILS: null,
    PAT_SAMAGRI: null,
    PAT_SAMAGRIPRICE: null,
    PAT_TAC: null,
  });
  const { setLoader } = useContext(LoaderContext);
  const currentUrl = window.location.href;

  useEffect(() => {
    fetchTempleDetails();
  }, [location]);

  const fetchTempleDetails = async () => {
    setLoading(true);
    try {
      const response = await GetPoojaAtTempleDetailsBySlug(slug);
      if (
        response.ResponseCode === "0" &&
        response.ResponseMessage === "list"
      ) {
        setLoading(false);
        const Data = response.DATA[0];
        if (!Data) {
          navigate("/*");
          return;
        }
        setTemple(Data);
        GetFAQListByServiceData(Data?.PAT_ID);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching temple details:", error);
    }
    setLoading(false);
  };

  const GetFAQListByServiceData = async (PujaID) => {
    // debugger;
    setLoader(true);
    try {
      const response = await GetFAQListByService(
        FaqModuleID?.PujaAtTempleBooking,
        PujaID
      );

      if (response) {
        setLoader(false);
        const modalData = response.DATA;
        console.log(modalData);
        setFaq(modalData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  if (loading) {
    return <div className="text-center mt-5">Loading temple details...</div>;
  }

  if (!temple) {
    return <div className="text-center mt-5">Temple not found.</div>;
  }

  const clickToBook = (temple) => {
    console.log(temple, "ddddddddddds33");

    {
      setModelRequestData({
        ...modelRequestData,
        Action: null,
        Row: temple.Row,
        PAT_ID: temple.PAT_ID,
        PAT_NAME: temple.PAT_NAME,
        PAT_PRICE: temple.PAT_PRICE,
        PAT_CONVENIENCEFEE: temple.PAT_CONVENIENCEFEE,
        PAT_IMAGE: temple.PAT_IMAGE,
        PAT_ADDRESS: temple.PAT_ADDRESS,
        PAT_DETAILS: temple.PAT_DETAILS,
        PAT_SAMAGRI: temple.PAT_SAMAGRI,
        PAT_SAMAGRIPRICE: temple.PAT_SAMAGRIPRICE,
        PAT_TAC: temple.PAT_TAC,
        DARSHAN_PRICE: temple.DARSHAN_PRICE,
        DARSHAN_TIME: temple.DARSHAN_TIME,
        TR_ID: temple.TR_ID,
        CONVENIENCE_FEE: temple.CONVENIENCE_FEE,
        TR_SHORTDETAILS: temple.TR_SHORTDETAILS,
      });
    }
    let addRawMaterialRequestData = {
      Action: null,
      Row: temple.Row,
      PAT_ID: temple.PAT_ID,
      PAT_NAME: temple.PAT_NAME,
      PAT_PRICE: temple.PAT_PRICE,
      PAT_CONVENIENCEFEE: temple.PAT_CONVENIENCEFEE,
      PAT_IMAGE: temple.PAT_IMAGE,
      PAT_ADDRESS: temple.PAT_ADDRESS,
      PAT_DETAILS: temple.PAT_DETAILS,
      PAT_SAMAGRI: temple.PAT_SAMAGRI,
      PAT_SAMAGRIPRICE: temple.PAT_SAMAGRIPRICE,
      PAT_TAC: temple.PAT_TAC,
      DARSHAN_PRICE: temple.DARSHAN_PRICE,
      DARSHAN_TIME: temple.DARSHAN_TIME,
      TR_ID: temple.TR_ID,
      CONVENIENCE_FEE: temple.CONVENIENCE_FEE,
      TR_SHORTDETAILS: temple.TR_SHORTDETAILS,
    };
    if (isAuthenticated) {
      navigate("/puja-at-temple-booking", {
        state: temple,
      });
    } else {
      setLoginPopUp(true);
    }
  };
  const createMarkup = (html) => {
    return { __html: html };
  };

  const FaqObj = [
    {
      question: "What services does Myomnamo offer?",
      answer:
        "Myomnamo offers a range of spiritual services, including Puja and Darshan bookings. You can book experienced Pandits for rituals or arrange daily pujas. Our E-Store provides access to religious goods, and Puja samgari, puja kits. Additionally, Myom namo offers horoscope services.",
      color: "#ffa415",
    },
    {
      question: "Can I schedule a temple visit through My OmNamo?",
      answer:
        "Yes, Myomnamo allows you to book temple visits online for your convenience. You can easily select your preferred temple, date, and time through our app. My Om Namo specializes in offering customized puja packages and online Darshans.",
      color: "#fc5528",
    },
    {
      question: "Can I book personalized consultations with spiritual mentors?",
      answer:
        "Yes, Myomnamo provides a platform to book personalized consultations with experienced spiritual mentors. You can connect with mentors who can offer guidance and support on your spiritual journey. These sessions can provide personalized advice and practices tailored to your specific needs",
      color: "#8139e7",
    },
    // {
    //   question: "Why is it important How Volunteer?",
    //   answer:
    //     "There are many variations of passages the majority have suffered alteration in some form injected humour, or randomised words.",
    //   color: "#399be7",
    // },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": temple?.MetaTitle,
    "description": temple?.MetaDescription,
    "image": temple?.imageURL || "default-image-url.jpg",
    "author": {
      "@type": "Organization",
      "name": "Myomnamo",
      "url": "https://www.myomnamo.com"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Myomnamo",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.myomnamo.com"
      }
    },
    "datePublished": temple?.publishedDate || null,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": temple?.CannonicalLink
    }
  };

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": temple?.MetaTitle,
    "description": temple?.MetaDescription,
    "url": temple?.CannonicalLink,
    "image": temple?.imageURL || "default-image-url.jpg",
    "inLanguage": "en",
    "publisher": {
      "@type": "Organization",
      "name": "Myomnamo",
      "url": `https://www.myomnamo.com/puja-at-temple/${temple?.PoojaAtTempleSlug}`
    }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://www.myomnamo.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Temples",
        "item": "https://www.myomnamo.com/puja-at-temple"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": temple?.MetaTitle,
        "item": temple?.CannonicalLink
      }
    ]
  };
  return (
    <>
      <Helmet>
        <title>{temple?.MetaTitle}</title>
        <meta name="description" content={temple?.MetaDescription} />
        <link rel="canonical" href={temple?.CannonicalLink} />

        {/* Open Graph Tag */}

        {/* <!-- Open Graph tags --> */}
        <meta property="og:title" content={temple?.MetaTitle} />
        <meta property="og:description" content={temple?.MetaDescription} />
        <meta property="og:image" content="" />
        <meta
          property="og:url"
          content={`https://www.myomnamo.com/puja-at-temple/${temple?.PoojaAtTempleSlug}`}
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="MyOmNamo" />
        <meta property="og:locale" content="en_IN" />

        {/* <!-- Twitter Card tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={temple?.MetaTitle} />
        <meta name="twitter:description" content={temple?.MetaDescription} />
        <meta name="twitter:image" content="" />
        {temple?.ExtraMetaTag}

        {/* Breadcrumb JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>

        {/* WebPage JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(webPageSchema)}
        </script>

        <script type="application/ld+json">
          {JSON.stringify(articleSchema)}
        </script>
      </Helmet>
      <div className="PujaDetails">
        <div className="PujaDetailsContainer">
          <div className="puja-summary-section">
            {/* <div className="pujaDetails" style={{ display: "flex", gap: "20px" }}> */}
            <div className="left-puja-details">
              <img
                src={temple.PAT_IMAGE}
                alt="Puja-Img"
                onError={(e) => {
                  e.target.onerror = null; // Prevent infinite loop
                  // e.target.src = placeholderImg; // Set fallback image
                }}
                className="puja-img" // Bootstrap classes for responsiveness and rounded corners
              />
              {/* {pujaDetailsData.pujaDiscount && (
          <div
            className="position-absolute top-0 start-0 bg-danger text-white px-2 py-1 rounded"
            style={{ fontSize: "14px", fontWeight: "bold", margin: "10px" }}
          >
            {pujaDetailsData.pujaDiscount}% OFF
          </div>
        )} */}
            </div>

            <div className="right description-container">
              <div className="puja-header">
                <div
                  style={{
                    justifyContent: "end",
                    display: "flex",
                    width: "100%",
                  }}
                >
                  {" "}
                  <button
                    className="pujacustom-btn Normal-app-btn d-none d-lg-block d-md-block"
                    onClick={() => clickToBook(temple)}
                  >
                    Proceed to Book
                  </button>
                </div>
                <h1 className="mb-0">{temple.PAT_NAME}</h1>
              </div>
              <div className="d-flex d-lg-none d-md-none mb-1 justify-content-center">
                <button

                  className="btn btn-block Normal-app-btn w-80"
                  onClick={() => clickToBook(temple)}
                >
                  Proceed to Book
                </button>
              </div>
              <div className="price-tag position-relative d-inline-block p-2 d-flex  align-items-center">
                <div
                  className="text-dark px-3 py-1 rounded"
                  style={{ background: "#efb423", marginRight: "10px" }}
                >
                  <strong>₹ {temple.PAT_PRICE}</strong>
                </div>
                {/* <div
              className="text-muted"
              style={{ textDecoration: "line-through" }}
            >
              {pujaDetailsData?.DiscountAmount}
            </div> */}
                <button
                  className=" custom-share-btn"
                  onClick={() => setShowModal(true)}
                  title="Share"
                >
                  <i className="fa-solid fa-up-right-from-square mx-1"></i>
                  Share
                </button>
              </div>


              {temple.ShortDescription !== null && temple.ShortDescription !== undefined && (
                <div className="mb-3 ">
                  {/* <h5>Puja Details:</h5> */}
                  <p
                    dangerouslySetInnerHTML={{
                      __html: temple.ShortDescription,
                    }}
                  />
                </div>
              )}


              {temple.PAT_SAMAGRI !== null && temple.PAT_SAMAGRI !== undefined ? (
                <div className="mb-3">
                  <h5>Samagri:</h5>

                  <div
                    dangerouslySetInnerHTML={createMarkup(temple.PAT_SAMAGRI)}
                  />
                </div>
              ) : (
                ""
              )}

              {temple?.KeyFeature !== null && temple?.KeyFeature !== undefined ? (
                <div className="samagri">
                  <h5>Key Features</h5>
                  <div dangerouslySetInnerHTML={{ __html: temple?.KeyFeature }} />
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          {temple?.PAT_DETAILS !== null && temple?.PAT_DETAILS !== undefined ? (
            <div className="detailed-description">
              <h5>Description</h5>
              <div dangerouslySetInnerHTML={{ __html: temple?.PAT_DETAILS }} />
            </div>
          ) : (
            ""
          )}

          {/* FAQ Section */}

          {FAQ?.length > 0 && (
            <div className="faq-section">
              <section className="faq-one faq-one--page">
                <div
                  className="container"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <div className="sec-title text-center">
                    <h6
                      className="sec-title__tagline bw-split-in-right"
                      style={{
                        perspective: "400px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {/* <img className=" tagline-img" src={batuk} alt="" /> FAQ */}
                      <img className=" tagline-img" src={batuk} alt="" /> FAQs
                      {/* <span className="sec-title__tagline__border"></span> FAQ */}
                    </h6>
                    <h3
                      className="sec-title__title bw-split-in-left"
                      style={{ perspective: "400px", textAlign: "center" }}
                    >
                      Frequently Asked Questions.
                    </h3>
                  </div>
                  <div className="row">
                    <div className="col-xl-2"></div>
                    <div className="col-xl-8">
                      <div className="faq-one__accordion careox-accordion">
                        {FAQ?.map((faq, index) => (
                          <div
                            key={index}
                            className={`accrodion ${activeIndex === index ? "active" : ""
                              }`}
                            style={{ "--accent-color": faq.color }}
                          >
                            <div
                              className="accrodion-title"
                              onClick={() => toggleFAQ(index)}
                            >
                              <h4>
                                <span
                                  className="accrodion-title__number"
                                  style={{
                                    marginRight: "10px",
                                    fontWeight: "500",
                                  }}
                                ></span>
                                {faq.QUESTION}
                                <span className="accrodion-title__icon"></span>
                              </h4>
                            </div>
                            <div
                              className="accrodion-content"
                              style={{
                                maxHeight: activeIndex === index ? "200px" : "0",
                                overflow: "hidden",
                                transition: "max-height 0.5s ease-in-out",
                              }}
                            >
                              <div className="inner">
                                <p>{faq.ANSWER}</p>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="col-xl-2"></div>
                  </div>
                </div>
              </section>
            </div>
          )}
        </div>

        {/* <ProductBookingModal
        show={productBookingModal}
        onHide={() => setProductBookingModal(false)}
        product={pujaDetailsData}
      />*/}
        {loginPopUp && (
          <LoginPopUp show={loginPopUp} onHide={() => setLoginPopUp(false)} />
        )}
      </div>
      <ShareLinkModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        shareUrl={currentUrl}
        message={PujaAtTempleShareMassage} // Optional
        title="Spread the word" // Optional
      />
    </>

  );
};

export default PoojaAtTempleDetails;
